module.exports = __webpack_public_path__ + "img/user-logo.61d90d84.png";